import { LAUNCHER_FAMILY_LABELS, type DeviceDto, type DeviceLauncherNotice } from '@gc/shared';

import { api } from '@/lib/api';

/**
 * The board's launcher notices (owner, 2026-10-05) — see `DeviceTile` for
 * what one means on the tile, and the API's `devices/launcher-notices.ts` for
 * how the server derives them. Kept out of the tile so the two decisions that
 * are not markup — what a tile lists, and where Done goes — are testable in
 * plain node (no DOM emulation ships in this workspace).
 */

/**
 * The notices a tile shows. A server one deploy behind sends no key at all,
 * and a console never has any, so absent reads as none.
 */
export function launcherNoticesOf(
  device: Pick<DeviceDto, 'launcherNotices'>,
): readonly DeviceLauncherNotice[] {
  return device.launcherNotices ?? [];
}

/**
 * The launcher's own name ("Epic Games"), the same in every language — it is
 * what is printed on the launcher staff will be opening. A family a newer
 * server knows and this page does not falls back to its id, never a blank.
 */
export function launcherNoticeLabel(notice: Pick<DeviceLauncherNotice, 'family'>): string {
  return LAUNCHER_FAMILY_LABELS[notice.family] ?? notice.family;
}

/** `POST /devices/:deviceId/launcher-notices/:auditId/done`. */
export function launcherNoticeDonePath(deviceId: string, auditId: string): string {
  return `/devices/${deviceId}/launcher-notices/${auditId}/done`;
}

/**
 * Done: staff have signed the venue account back in. The server answers 204
 * and is idempotent, so a double press or a second terminal is harmless; the
 * caller re-reads the board for the notice to go, and a refusal is thrown so
 * the board can say why the notice stayed.
 */
export async function markLauncherNoticeDone(deviceId: string, auditId: string): Promise<void> {
  await api.post<void>(launcherNoticeDonePath(deviceId, auditId));
}
